import { Box, Divider, Paper } from "@mui/material";
import React, { useContext, useState } from "react";
import { AppContext } from "../../../../App";
import { action, API, controller } from "../../../../api/api";
import {
  BGNestedObjToFromData,
  lsGet,
  PrintDiv,
  RandomCode,
  RmvArryEmptyProp,
} from "../../../../hooks/Method";
import { Model } from "../../../../hooks";
import { Alert, Dialog, Snackbar } from "../../../../layout";
import PrintReceipt from "./PrintReceipt/PrintReceipt";
import { useNavigate } from "react-router-dom";
import CheckoutCustomer from "./CheckoutCustomer/CheckoutCustomer";
import Payments from "./PaymentsReceived";
import ReceiveAmount from "./AmountToPay";
import PaymentType from "./PaymentType";
import GiveChangePopup from "./GiveChangePopup";
import { CartContext } from "../POS";

const Checkout = () => {
  const { access } = useContext(AppContext);
  const activeReg = lsGet("activeReg");
  const navigate = useNavigate();
  const [received, setReceived] = useState(0);
  const [error, setError] = useState("");
  const { SellMdl } = Model();
  const { setLoader } = useContext(AppContext);
  const { cartData, setCartData } = useContext(CartContext);
  const [receiptData, setReceiptData] = useState({});
  const [showChangeAlert, setShowChangeAlert] = useState(false);
  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "success",
    msg: "",
  });
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleAddPayment = (method) => {
    if (method) {
      var _received = parseFloat(received || 0);
      if (_received > 0) {
        // if made partial payment
        if (parseFloat(received) + cartData.received >= cartData.netPayable)
          handleSubmitSell(method);
        // full payment
        else handleAddPartialPayment(method);
      } else setError("Please enter the amount");
    }
  };

  const handleAddPartialPayment = (method) => {
    setCartData((j) => ({
      ...j,
      received: parseFloat(j.received || 0) + parseFloat(received || 0),
      payments: [
        ...j.payments,
        {
          key: RandomCode(),
          name: method.name,
          amount: received,
          payTypeId: method.id,
          createDate: new Date().toISOString(),
          newPayment: true,
        },
      ],
    }));
    // Show success message
    setSnackbar((s) => ({
      ...s,
      show: true,
      msg: `Successfully received $${received}`,
    }));
  };

  const handlePrintReceipt = (val = receiptData) => {
    setTimeout(() => {
      PrintDiv("printSellRecept");
      setCartData((j) => ({
        ...SellMdl(),
        taxRate: val.taxRate || 0,
        taxId: val.taxId || "",
      }));
      navigate("/pos");
    }, 500);
  };

  const handleSubmitSell = (method, status = "", type = "") => {
    if (!error && activeReg) {
      setLoader(true);
      const onComplete = (res) => {
        setLoader(false);
        if (res && res.status === 200) {
          var _sell = res.result;

          setReceiptData(_sell);

          _sell.change > 0
            ? setShowChangeAlert(true)
            : handlePrintReceipt(_sell);
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };

      var totalPayment = cartData.payments
        .map((p) => parseFloat(p.amount))
        .reduce((x, y) => x + y, 0);
      var totalReceived =
        parseFloat(totalPayment) + parseFloat(status === 1 ? 0 : received || 0);

      var change = status === 1 ? "" : totalReceived - cartData.netPayable;

      API(controller.Sell + action.Post).post(
        BGNestedObjToFromData(
          RmvArryEmptyProp({
            ...cartData,
            status,
            type,
            received: totalReceived,
            change,
            sellItems: cartData.sellItems.map((j) => ({
              ...j,
              id: "",
              prod: "",
              varProd: "",
            })),
            customer: "",
            sellRegId: activeReg.id,
            outletId: activeReg.outletId,
            sellDate: new Date().toISOString(),
            updateDate: cartData.id ? new Date().toISOString() : "",
            payments: [
              ...cartData.payments.map((p) => ({ ...p, payType: "", id: "" })),
              status === 1
                ? {}
                : {
                    amount: received,
                    payTypeId: method.id,
                    createDate: new Date().toISOString(),
                  },
            ],
          })
        ),
        onComplete
      );
    }
  };

  return (
    <>
      <Box className="d-none" id="printSellRecept">
        {receiptData && receiptData.id && <PrintReceipt data={receiptData} />}
      </Box>

      <Paper className="grid gap-1 md:gap-2 border-slate-200 border-2 rounded-lg shadow-sm">
        {/* -------- Amount to Pay Section --------- */}
        <div className="flex flex-wrap items-center justify-between p-3 md:p-5">
          <span className="text-lg md:text-3xl text-gray-500 font-semibold uppercase">
            Amount to Pay
          </span>

          {/* -------- Payment Receive Input Box --------- */}
          <div className="w-full md:max-w-[300px]">
            <ReceiveAmount {...{ error, received, setReceived, cartData }} />
          </div>
        </div>

        <Divider className="my-2" />

        {/* -------- Payment Method Section --------- */}
        <PaymentType {...{ handleAddPayment }} />

        {/* -------- Checkout Customer Features Section --------- */}
        <Divider className="my-2" />
        {access?.pos?.creditSale && (
          <div className="p-[10px] md:p-[20px]">
            <CheckoutCustomer handleSubmitSell={handleSubmitSell} />
          </div>
        )}
      </Paper>

      {/* -------- Payments --------- */}
      <Payments />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} autoHideDuration={1500} />
      <Snackbar {...{ snackbar, setSnackbar }} />

      {/* Change Amount Alert */}
      <Dialog show={showChangeAlert} onClose={false} maxWidth="sm">
        <GiveChangePopup
          {...{
            handlePrintReceipt,
            setShowAlert: setShowChangeAlert,
            receiptData,
            setReceiptData,
          }}
        />
      </Dialog>
    </>
  );
};

export default Checkout;
